import React from "react";
import { Box, Container, Paper, Typography, Link } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';

// import YouTubeIcon from '@mui/icons-material/YouTube';
// import InstagramIcon from '@mui/icons-material/Instagram';

export function Footer() {
    return (
        <Paper sx={{
                mt: 'auto',
                width: '100%',
                zIndex: '10'  }} 
            component="footer"
            square variant="outlined">
            <Container maxWidth="lg">
                <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    position: 'relative',
                    py: { xs: 1.5, md: 2 },
                    minHeight: { xs: '48px', md: '56px' },
                    gap: { xs: 1, md: 2 }
                }}
                >
                    {/* Left side: Copyright and links */}
                    <Box sx={{ 
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        gap: { xs: 0.5, sm: 2 },
                        flex: { xs: 'none', sm: 1 },
                        justifyContent: { xs: 'flex-start', md: 'center' }
                    }}>
                        {/* First line on mobile: Copyright */}
                        <Typography variant="caption" color="text.primary" sx={{ 
                            fontSize: { xs: '0.7rem', sm: '0.75rem' },
                            whiteSpace: 'nowrap'
                        }}>
                            {`©${new Date().getFullYear()} Plancrafted Inc.`}
                        </Typography>
                        
                        <Typography variant="caption" color="text.secondary" sx={{ 
                            fontSize: '0.75rem',
                            display: { xs: 'none', sm: 'block' }
                        }}>
                            •
                        </Typography>
                        
                        {/* Second line on mobile: Links */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}>
                            <Link
                                component={RouterLink}
                                to="/privacy-policy"
                                sx={{
                                    color: 'text.secondary',
                                    textDecoration: 'none',
                                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                    whiteSpace: 'nowrap',
                                    '&:hover': {
                                        color: 'primary.main',
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                Privacy Policy
                            </Link>
                            <Typography variant="caption" color="text.secondary" sx={{ 
                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                            }}>
                                •
                            </Typography>
                            <Link
                                component={RouterLink}
                                to="/contact"
                                sx={{
                                    color: 'text.secondary',
                                    textDecoration: 'none',
                                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                    whiteSpace: 'nowrap',
                                    '&:hover': {
                                        color: 'primary.main',
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                Contact
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Paper>
    );
};